export default {
	init() {
		let forms = document.querySelectorAll('form');

		for (var i=0; i<forms.length; i++) {
			forms[i].addEventListener('submit', event => {
				let submitButton = event.target.querySelector('.c-button');

				if (submitButton) {
					submitButton.disabled = true
				}
			});
		}
	}
}